import React from "react";
import SampleProductsPage from "../../../features/admin/sample-products/sample-products-page";

export default function SampleProducts() {
  return <SampleProductsPage />;
}
